import { Button, Space } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import React from 'react';

import type { EdutainmentCategory } from './types';

export const getTableColumns = (args: {
  handleEditButtonClick: (record: EdutainmentCategory) => void;
  handleDetailButtonClick: (record: EdutainmentCategory) => void;
}) => {
  const { handleEditButtonClick, handleDetailButtonClick } = args;

  const columns: ColumnsType<EdutainmentCategory> = [
    {
      title: '育樂類別',
      dataIndex: 'category',
    },
    {
      title: '類別介紹',
      dataIndex: 'description',
    },
    {
      title: '操作',
      dataIndex: 'actions',
      width: 250,
      fixed: 'right',
      render: (_, record) => {
        return (
          <Space align="center">
            <Button
              type="primary"
              onClick={() => handleDetailButtonClick(record)}
            >
              查看
            </Button>
            <Button onClick={() => handleEditButtonClick(record)}>編輯</Button>
            <Button
              type="primary"
              danger
              onClick={() => console.log('Delete:', record._id)}
            >
              刪除
            </Button>
          </Space>
        );
      },
    },
  ];

  return columns;
};
